import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { events } from '../data/events';
export function Events() {
  return <div className="w-full bg-club-canvas" data-id="element-804">
      {/* Page Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-805">
        <div className="absolute inset-0 z-0 bg-club-green" data-id="element-806">
          <div className="absolute inset-0 opacity-10" data-id="element-807">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-808">
              <defs data-id="element-809">
                <pattern id="pattern-events" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-810">
                  <path d="M0 40L40 0H20L0 20M40 40V20L20 40" fill="currentColor" fillOpacity="0.5" data-id="element-811" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#pattern-events)" data-id="element-812" />
            </svg>
          </div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-813">
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-814">
            Events Calendar
          </motion.h1>
          <motion.p className="text-lg text-club-canvas/80 font-light max-w-2xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-815">
            Discover upcoming social, sporting, and cultural events at the Club.
          </motion.p>
        </div>
      </section>

      {/* Events List */}
      <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-816">
        <div className="space-y-8" data-id="element-817">
          {events.map((event, index) => <motion.div key={event.id} className="flex flex-col md:flex-row bg-white border border-club-border rounded-sm overflow-hidden hover:border-club-gold transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-818">
              <div className="w-full md:w-1/3 h-48 md:h-auto relative" data-id="element-819">
                <img src={event.image} alt={event.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-820" />
              </div>
              <div className="w-full md:w-2/3 p-6 md:p-8 flex flex-col justify-center" data-id="element-821">
                <div className="flex items-center gap-4 text-club-gold mb-3 text-sm font-medium" data-id="element-822">
                  <span className="flex items-center" data-id="element-823">
                    <Calendar size={14} className="mr-1" data-id="element-824" /> {event.date}
                  </span>
                  <span className="flex items-center" data-id="element-825">
                    <Clock size={14} className="mr-1" data-id="element-826" /> {event.time}
                  </span>
                </div>
                <h3 className="text-2xl mb-3" data-id="element-827">{event.title}</h3>
                <p className="text-club-ink/70 mb-4 line-clamp-2" data-id="element-828">
                  {event.desc}
                </p>
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-club-border" data-id="element-829">
                  <span className="flex items-center text-sm text-club-ink/60" data-id="element-830">
                    <MapPin size={14} className="mr-1" data-id="element-831" /> {event.loc}
                  </span>
                  <Link to={`/events/${event.id}`} className="text-sm font-medium text-club-green hover:text-club-gold transition-colors flex items-center" data-id="element-832">
                    RSVP <ArrowRight size={14} className="ml-1" data-id="element-833" />
                  </Link>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}